<template>
  <div style="height:100%">
    <Card style="min-height:100%">
      <Row>
        <Form ref="roleForm"
              :model="role"
              :label-width="150">
          <FormItem label="角色名称："
                    prop="roleName">
            <Input v-model="role.roleName"
                   style="width:400px"
                   readonly></Input>
          </FormItem>
          <FormItem>
            <Transfer  ref="refTransfer"
                      :data="totalUserArray"
                      not-found-text="没有数据"
                      :targetKeys="chosedKeys"
                      :titles="choseTitles"
                      @on-change="changeChosedUser">
                    	<div :style="{float: 'right',margin: '5px 16px 6px'}">
									<Button @click="clearSelect">清空选择</Button>
							</div> 
            </Transfer>
          </FormItem>
          	<br/>
					<FormItem>
						 <Button type="primary" size="large" style="width: 100px;font-size: 14px;" @click="saveUserRole">保存</Button>
						 <Button size="large" style="width: 100px;margin-left: 8px;font-size: 14px;" @click="cancel">返回</Button>
					</FormItem>
        </Form>
      </Row>
    </Card>
  </div>
</template>
<script>
import {
  queryUserRoleByProperties,
  editUserRole
} from "@/api/user/role.js";
export default {
  name: "RoleUser",
  data () {
    return {
      unchosedRequestVO: {
        userName: "",
        roleID: "",
        choice: 0
      },
      chosedRequestVO: {
        userName: "",
        roleID: "",
        choice: 1
      },
      choseTitles: ["未选择用户", "已选择用户"],
      unchosedUserArray: [],
      chosedUserArray: [],
      chosedKeys: [],
      editUserRoleRequestVO: {
        roleID: "",
        userIDs: ""
      }
    };
  },
  computed: {
    role () {
      return this.$store.state.user.role;
    },
    totalUserArray () {
      return [...this.unchosedUserArray, ...this.chosedUserArray];
    }
  },
  created () {
    this.renderUnchosedUserArray();
    this.renderChosedUserArray();
  },
  methods: {
    renderUnchosedUserArray () {
      this.unchosedRequestVO.roleID = this.role.roleID;
      queryUserRoleByProperties(this.unchosedRequestVO).then(res => {
        if (res.data.result) {
          this.unchosedUserArray = res.data.data.map(element => {
            let resultObj = new Object();
            resultObj.key = element.userID;
            resultObj.label = element.userLoginName;
            return resultObj;
          });
        }
      });
    },
    renderChosedUserArray () {
      this.chosedRequestVO.roleID = this.role.roleID;
      queryUserRoleByProperties(this.chosedRequestVO).then(res => {
        if (res.data.result) {
          this.chosedUserArray = res.data.data.map(element => {
            let resultObj = new Object();
            resultObj.key = element.userID;
            resultObj.label = element.userLoginName;
            return resultObj;
          });
          this.chosedKeys = res.data.data.map(element => {
            return element.userID;
          });
        }
      });
    },
    changeChosedUser (newTargetKeys) {
      this.chosedKeys = newTargetKeys;
      let chosedIdString = newTargetKeys.join("@");
      this.editUserRoleRequestVO.roleID = this.role.roleID;
      this.editUserRoleRequestVO.userIDs = chosedIdString;
      editUserRole(this.editUserRoleRequestVO).then(res => { });
    },
    clearSelect(){
			this.$refs.refTransfer.$children[0].toggleSelectAll();
			this.$refs.refTransfer.$children[2].toggleSelectAll();
		},
    //保存
    saveUserRole(){
			let chosedIdString = this.chosedKeys.join("@");
			this.editUserRoleRequestVO.roleID = this.role.roleID;
			this.editUserRoleRequestVO.userIDs = chosedIdString;
			editUserRole(this.editUserRoleRequestVO).then(res => {
				if(res.data.result){
					this.$Message.success(res.data.data);
				}
			});
		},
    //取消
    cancel(){
			this.$router.push("roleList");
		},
  }
};
</script>
